import {Injectable} from '@angular/core'
import {formStorage} from './local-storage'
import debounce from 'lodash.debounce'
import {Form} from '../../../../../form-editor/src/core/model'

@Injectable()
export class PersistanceService {

  private storage = formStorage

  getPersistedForm(): Form {
    return this.storage.load()
  }

  persistForm = debounce((form: Form) => {
    this.storage.save(form)
  }, 1200)
}
